// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-fn-temporary-resident-banking/form-item-fn-temporary-resident-banking.component.scss
// module id = 894
// module chunks = 0